import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";

import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";

export const Irmaos = ({ data }) => {
  const { roleKeycloack, user } = useAuthProvider();

  const columnsIrmaos = [
    {
      Header: "Nome do Irmão",
      accessor: "pessoaFisicaIrmao",
      Cell: (props) => {
        const nome = props?.value?.nome;

        return (
          <Text whiteSpace={"normal"} title={nome}>
            {nome}
          </Text>
        );
      },
    },

    {
      Header: "Filiação em Comum",
      accessor: "filiacoes",
      Cell: (props) => {
        const filiacoes = props.value
          .sort((a, b) => a.tipoFiliacao?.localeCompare(b.tipoFiliacao))
          .map((item, index) => (
            <React.Fragment key={index}>
              {item.nome}
              <Text as="span" textTransform="capitalize">
                {item?.tipoFiliacao
                  ? ` (${item?.tipoFiliacao?.toLowerCase()})`
                  : ""}
              </Text>
              {index < props.value.length - 1 && <hr />}
            </React.Fragment>
          ));

        return <Text wordBreak={"break-word"}>{filiacoes}</Text>;
      },
    },
    {
      Header: "Situação",
      accessor: "situacao",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      Cell: (props) => {
        const riscoVida = props?.row?.original?.riscoVida;

        if (
          riscoVida === "S" &&
          !(
            roleKeycloack.includes(criancaFunc.visualizarTudo) ||
            roleKeycloack.includes(
              servicoAcolhimentoFunc.visualizarPartePPCAAM
            ) ||
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
            ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
              roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
              user?.orgaoExterno?.includes(
                props?.row?.original?.idPessoaJuridica
              ))
          )
        ) {
          return <Text></Text>;
        } else {
          return (
            <Text whiteSpace={"nowrap"}>{props.value ? props?.value : ""}</Text>
          );
        }
      },
    },
  ];

  return data && data.length > 0 ? (
    <Box display="break-page">
      <Group bgColor="#fff" title="Irmãos" py="12px" mtDivider="5px">
        <IrmaoTable
          disableHeaderOptions={true}
          irmaos={true}
          columns={columnsIrmaos}
          entidade="irmaos"
          data={data}
          filiacoes={data}
          isPrint={true}
        />
      </Group>
    </Box>
  ) : (
    <Box display="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Irmãos"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
